import type { IMarket } from "~/types/event";
import type { Platform } from "~/types/platform";

export const uniquePlatforms = (markets: readonly IMarket[]): Platform[] => [
  ...new Set(markets.map(({ platform }) => platform)),
];
